import styled from 'styled-components';

const STooltip = styled.div`
  position: relative;
`;

const STooltipFloating = styled.div`
  position: absolute;
  z-index: 1;
  top: calc(100% + 12px);
  right: -2px;
  display: grid;
  grid-template-columns: 1fr 32px;
  width: 229px;
  opacity: 0;
  visibility: hidden;
  padding: 4px 8px 12px 16px;
  border-radius: 4px;
  background-color: #1a055d;

  > p {
    padding: 8px 4px 0 0;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
  }

  > button {
    position: relative;
  }

  &::before {
    content: '';
    background-color: #1a055d;
    border-radius: 2px;
    height: 16px;
    position: absolute;
    right: 10px;
    top: -6px;
    transform: rotate(45deg);
    width: 16px;
  }

  &[data-active='true'] {
    opacity: 1;
    visibility: visible;
  }
`;

export { STooltip, STooltipFloating };
